import { AlertTriangle } from "lucide-react";

export const CrisisBanner = () => {
  return (
    <div
      data-testid="crisis-banner"
      className="w-full bg-amber-50 border-b border-amber-200 text-amber-900"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-2.5 flex items-start md:items-center gap-3 text-xs md:text-sm">
        <AlertTriangle size={16} className="shrink-0 mt-0.5 md:mt-0" />
        <p className="leading-relaxed">
          <strong className="font-semibold">Atenção: </strong>
          este site não oferece atendimento de urgência. Em crise ou risco de vida, ligue para{" "}
          <a href="tel:188" data-testid="crisis-cvv" className="underline font-semibold">CVV 188</a>,{" "}
          <a href="tel:192" data-testid="crisis-samu" className="underline font-semibold">SAMU 192</a> ou{" "}
          <a href="tel:193" data-testid="crisis-bombeiros" className="underline font-semibold">Bombeiros 193</a>.
        </p>
      </div>
    </div>
  );
};
